/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import SessionStore from "../../stores/SessionStore";

type Headers = {
  Device: string;
  Token: string;
  /**
   * @deprecated DO NOT USE! All APIs must read this from /verify-auth response. To be removed.
   */
  UserId: string;
  /**
   * @deprecated DO NOT USE! All APIs must read this from /verify-auth response. To be removed.
   */
  IsSupportAdmin: string;
  "Content-Type": string;
  /**
   * @deprecated DO NOT USE! All APIs must read this from /verify-auth response. To be removed.
   */
  actorId: string;
};

export const headers = (): Headers => {
  return {
    Device: SessionStore.getSelectedDevice(),
    Token: SessionStore.getToken(),
    UserId: SessionStore.getUserId(),
    IsSupportAdmin: SessionStore.isSupportAdmin(),
    "Content-Type": "application/json",
    actorId: SessionStore.getUserId(),
  };
};
